module.exports = __webpack_public_path__ + "static/media/osu-collection-manipulator-1.6d003726.gif";